export const links = {
  skool: "https://www.skool.com/radardigital/about",
  mercadopago:
    "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=facbcf842a654b5bb86154e1e99af913",
  whatsapp: "https://chat.whatsapp.com/FaXwTNHKJaB44hVJYF7QmI",
  instagram: "https://www.instagram.com/marketingconmarcos/",
};

export const heroImage =
  "https://cdn.magicpatterns.com/uploads/fN3dBZJ8xPnfMaDHiKMoSp/Landing_Page_Hero_Color_Upgrade.png";

export const navLinks = [
  { label: "Método", href: "#metodo" },
  { label: "Comunidad", href: "#comunidad" },
  { label: "Programa", href: "#programa" },
  { label: "Preguntas", href: "#faq" },
];

export const stripItems = [
  "Formación paso a paso",
  "Comunidad en Skool",
  "2 asesorías semanales",
  "Precio fundador",
];

export const steps = [
  { title: "Investigá la demanda", description: "Detectá problemas e ideas que las personas ya buscan resolver." },
  { title: "Modelá tu propuesta", description: "Analizá referencias para crear contenido propio, original y útil." },
  { title: "Creá tu ebook", description: "Organizá el contenido y apoyate en IA para producir y revisar tu producto." },
  { title: "Prepará tu oferta", description: "Definí qué recibe el comprador y por qué le sirve." },
  { title: "Armá tu página", description: "Prepará la página de ventas, el cobro y la entrega del ebook." },
  { title: "Atraé compradores", description: "Aprendé a crear contenido, creativos y campañas para dar a conocer tu oferta." },
];

export const communityExtras = [
  { title: "Formación en Skool", description: "Módulos ordenados para avanzar a tu ritmo, desde la idea hasta la venta." },
  { title: "Comunidad activa", description: "Compartí tu proceso con otras personas que también están creando su producto." },
];

export const cases = [
  { name: "Vilma · 65 años", result: "Su primera venta en menos de 15 días" },
  { name: "Leo", result: "Su primera venta en menos de 10 días" },
];

export const modules = [
  { title: "Bienvenida y primeros pasos", description: "Conocé la comunidad y organizá tu recorrido." },
  { title: "Investigación de producto", description: "Aprendé a investigar ideas de ebooks con demanda." },
  { title: "Modelar tu ebook", description: "Convertí tu investigación en un producto propio y original." },
  { title: "Páginas y entregables con IA", description: "Apoyate en Claude para crear y revisar tu ebook y página de ventas." },
  { title: "Hotmart", description: "Prepará tu producto, el cobro y la entrega para vender online." },
  { title: "Shopify", description: "Aprendé a configurar una tienda y el cobro con Mercado Pago en Argentina." },
  { title: "Creación de creativos", description: "Diseñá piezas para comunicar tu oferta y atraer compradores." },
  { title: "Facebook Ads", description: "Aprendé a configurar campañas, medir resultados y ajustar tu inversión." },
];

export const included = [
  "Formación completa para crear y vender tu ebook",
  "Comunidad en Skool",
  "Asesoría en vivo los miércoles",
  "Asesoría en vivo los viernes",
];

export type FaqItem = {
  q: string;
  a: string;
  link?: { label: string; href: string };
};

export const faqs: FaqItem[] = [
  {
    q: "¿Necesito experiencia o un ebook para entrar?",
    a: "No. La formación comienza con los primeros pasos y la investigación de ideas. Podés empezar sin un producto creado.",
  },
  {
    q: "¿Qué significa modelar un ebook?",
    a: "Es investigar referencias, entender la demanda y crear una propuesta propia. No se trata de copiar un ebook ajeno: trabajás sobre contenido original que sea útil para tu comprador.",
  },
  {
    q: "¿En cuánto tiempo puedo tener mi ebook listo?",
    a: "Depende del tema, del alcance del producto y del tiempo que puedas dedicarle. La formación te ayuda a organizar los pasos; no hay un plazo único ni una fecha garantizada para conseguir ventas.",
  },
  {
    q: "¿Cómo funcionan las asesorías?",
    a: "Tenemos dos asesorías semanales con Marcos, los miércoles y viernes, para resolver dudas sobre el producto, la oferta y la venta. Consultá los horarios vigentes antes de suscribirte si necesitás confirmar tu disponibilidad.",
  },
  {
    q: "¿Necesito invertir en publicidad?",
    a: "La formación incluye Facebook Ads y creación de creativos. Si activás anuncios, el presupuesto se paga aparte de la membresía. También trabajamos sobre cómo comunicar tu oferta mediante contenido.",
  },
  {
    q: "¿Hay otros costos además de la membresía?",
    a: "Las herramientas, plataformas de venta y medios de cobro que elijas pueden tener suscripciones o comisiones propias. Esos costos y la inversión en anuncios no están incluidos en Radar Digital.",
  },
  {
    q: "¿Puedo entrar si vivo fuera de Argentina?",
    a: "Podés consultar la comunidad y la suscripción en USD desde Skool. La opción de ARS 40.000/mes mediante Mercado Pago está dirigida a Argentina. La disponibilidad de cobros para tu propio ebook depende de tu país y de la plataforma que elijas.",
  },
  {
    q: "¿Qué pasa después de pagar en pesos?",
    a: "El pago en Mercado Pago corresponde a la membresía de Radar Digital, cuya comunidad está en Skool. Si necesitás ayuda para coordinar tu acceso, contactá a Marcos en Instagram:",
    link: { label: "@marketingconmarcos", href: "https://www.instagram.com/marketingconmarcos/" },
  },
  {
    q: "¿Puedo cancelar la suscripción?",
    a: "Sí. Si te suscribiste desde Skool, gestioná la cancelación allí. Si pagaste mediante Mercado Pago, gestioná la suscripción en Mercado Pago. Al cancelar, dejás de renovar la membresía; revisá en tu plataforma la fecha de finalización del período pagado.",
  },
  {
    q: "¿Cuál es el precio fundador?",
    a: "Durante la etapa fundadora, el ingreso cuesta USD 27/mes o ARS 40.000/mes para Argentina. El futuro precio de ingreso será USD 97/mes o ARS 150.000/mes. La oferta no depende de un contador de lugares.",
  },
];
